import create from 'zustand';
import { ReceiptStoreState } from '../models/receipt-store-models';

export const useReceiptStore = create<ReceiptStoreState>((set) => ({
    setReceipt: (receipt, lines) => set({ receipt, lines }),
    resetState: () => set({ receipt: undefined }),
}));
